import { cn } from "@bentolabs/kit/utils";

import { PointsLeaderboardCard } from "entities/points";
import { WasabiPointsCard } from "entities/points/wasabi-points-card";
import { usePointsAccount } from "shared/api/use-points-account-query";

import { Pools } from "./ui/pools/pools";
type Props = { className?: string };

export const Points = ({ className }: Props) => {
  const pointsAccountQuery = usePointsAccount();

  const pools = Object.values(pointsAccountQuery.data?.tokenPoints ?? {});

  return (
    <>
      <div
        className={cn(
          "mt-7.5 grid grid-cols-1 gap-1.5 overflow-hidden md:grid-cols-2",
          className
        )}
      >
        <WasabiPointsCard />
        <PointsLeaderboardCard />
      </div>

      <Pools pools={pools} className="mt-17.5" />
    </>
  );
};
